<template>
  <div style="height: 32rem" class="flex items-center">
    <div class="w-1/4 h-full p-6 mt-3 ml-3 shadow-lg bg-gray-50">
      <div
        @click="doScan"
        class="flex items-center justify-center h-16 text-white bg-yellow-500 rounded-lg shadow-lg cursor-pointer select-none w-44 active:bg-yellow-700"
      >
        <i class="iconfont icon-saoma" style="font-size: 20pt"></i>
        <span class="pl-1 text-lg">识别会员卡</span>
      </div>
      <el-divider></el-divider>

      <div v-if="card.card_id != '' && card.card_id != undefined">
        <p class="leading-none" style="margin-left: -0.5rem">
          <i
            class="iconfont icon-huiyuanqiagoumai"
            style="font-size: 50pt; color: #909090"
          ></i>
        </p>
        <p class="mb-3">
          <span class="text-base text-gray-400">卡号</span>
          <span class="pl-3 text-lg">{{ card.card_code }}</span>
        </p>
        <p class="mb-3">
          <span class="text-base text-gray-400">余额</span>
          <span class="pl-3 text-lg">{{ card.balance_amount }}</span>
          <span class="pl-1 text-xs">元</span>
        </p>
        <p class="mb-3">
          <span class="text-base text-gray-400">状态</span>
          <span class="pl-3 text-base">{{ card.state_name }}</span>
        </p>
        <p class="mb-3">
          <span class="text-base text-gray-400">类型</span>
          <span class="pl-3 text-base">{{ card.card_type_name }}</span>
        </p>
        <p class="mb-3"  v-if="card.card_tags.length>0">
          <span class="text-base text-gray-400">标签</span>
          <span class="text-base">
 <el-tag class="ml-2" type="info" v-for="tag in card.card_tags">{{tag}}</el-tag>
          </span>
        </p>
      </div>
      <div v-else>
        <el-empty :image-size="200" description="请先识别会员卡"></el-empty>
      </div>
    </div>
    <!--1-->

    <div class="w-2/4 h-full pt-6 pl-6 mt-3 ml-3 mr-3 shadow-lg bg-gray-50">
      <p class="text-lg text-gray-700">扣款金额</p>
      <div class="mt-3">
        <el-input-number
          v-model="amount_val"
          max="100000"
          :precision="2"
          size="large"
          class="mt-2"
        />
        &nbsp;
        <el-button @click="showNumPageFun()">小键盘</el-button>
      </div>
       <p class="mt-6 text-lg text-gray-700">关联单号</p>
      <div>
        <el-radio-group v-model="relateBillCodePrefix">
          <el-radio :label="1">MR</el-radio>
          <el-radio :label="2">QX</el-radio>
          <el-radio :label="3">零售</el-radio>
           <el-radio :label="4">处理商品</el-radio>
           <el-radio :label="5">到店付款</el-radio>
        </el-radio-group>
         <el-input size="small" v-model="relateBillCode" placeholder="输入单号" style="width:15rem;" maxlength="30" clearable />
      </div>

      <el-divider></el-divider>
      <el-button
        class="w-40"
        style="color: white"
        color="#626aef"
        @click="doPublish"
        >确定扣款</el-button
      >
    </div>
  </div>

  <ScanCard
    @receiveScanReslut="receiveScanReslutFun"
    @scanCardClose="scanCardCloseFun"
    :disScanTypeSwitch="true"
    :series="false"
    :fromw="fromw"
    :showView="showScanPage"
  >
  </ScanCard>

  <Keyboard
    :showView="showNumPage"
    @numCloseEvent="numCloseFun"
    @numConfirmEvent="numConfirmFun"
  >
  </Keyboard>

  <CardPwd
    :showView="showPwdPage"
    @closeEvent="pwdCloseFun"
    @confirmEvent="pwdConfirmFun">

  </CardPwd>

  <el-dialog title="" v-model="dialogResultVisible">

 <el-result icon="success" :title="printResult.tips" subTitle="">

      <template #extra>

              <el-descriptions column="1">

                 <el-descriptions-item label="单号" >{{printResult.bill_id}}</el-descriptions-item>
                 <el-descriptions-item label="时间">{{printResult.oper_time}}</el-descriptions-item>
                  <el-descriptions-item label="卡号" >{{printResult.relate_id}}</el-descriptions-item>
                 <el-descriptions-item label="金额" >{{printResult.amount_val}}元</el-descriptions-item>

                  <el-descriptions-item label="门店" >{{printResult.branch_name}}&nbsp;{{printResult.terminal_name}}</el-descriptions-item>

                  <el-descriptions-item label="收银">{{printResult.oper_user_name}}</el-descriptions-item>

              </el-descriptions>

             <el-button type="info" size="medium" @click="printAgain">补打单据</el-button>
        <el-button type="primary" size="medium" @click="dialogResultVisible=false">返回</el-button>
      </template>
    </el-result>

</el-dialog>
</template>
<script>
import { reactive, ref, toRefs } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import ScanCard from '../components/scanCard/index.vue'
import Keyboard from '../components/keyboard/index.vue'
import CardPwd from '../components/cardPwd/index.vue'
import { doConsume } from '@/utils/member.js'
import { noticePrint } from '@/utils/pos.js'
import md5 from 'js-md5'
export default {
  components: { ScanCard, Keyboard, CardPwd },
  setup () {
    const fromw = 3

    const resultField = reactive({
      dialogResultVisible: false,
      printResult: {},
      printAgain: () => {
        noticePrint(resultField.printResult.print_id, () => {
          ElMessage({
            showClose: true,
            message: '打印请求成功',
            type: 'success'
          })
        })
      }
    })
    /** 小键盘 **/
    const numFiled = reactive({
      amount_val: 0,
      showNumPage: false,
      numCloseFun: () => {
        numFiled.showNumPage = false
      },
      numConfirmFun: (val) => {
        numFiled.amount_val = parseFloat(val)
      },
      showNumPageFun: () => {
        numFiled.showNumPage = true
      }
    })

    /* 扫码的 */
    const scanField = reactive({
      card: {},
      showScanPage: false,
      receiveScanReslutFun: (cardParam) => {
        scanField.card = cardParam
      },
      scanCardCloseFun: () => {
        scanField.showScanPage = false
      },
      doScan: () => {
        if (
          scanField.card.card_id != '' &&
          scanField.card.card_id != undefined
        ) {
          ElMessageBox.confirm('本地已有会员卡信息，是否清空?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            scanField.card = {}
            scanField.showScanPage = true
          })
        } else {
          scanField.showScanPage = true
        }
      }
    })

    const pwdField = reactive({
      showPwdPage: false,
      pwdCloseFun: () => {
        pwdField.showPwdPage = false
      },
      pwdConfirmFun: (val) => {
        pwdField.showPwdPage = false
        afterDoPublish(val)
      }

    })

    const doPublish = () => {
      if (scanField.card.card_id == '' || scanField.card.card_id == undefined) {
        ElMessage({
          showClose: true,
          message: '请先识别会员卡',
          type: 'error'
        })
        return
      }

      if (parseFloat(numFiled.amount_val) <= 0) {
        ElMessage({
          showClose: true,
          message: '请输入扣款金额',
          type: 'error'
        })
        return
      }

      ElMessageBox.confirm(
        '是否确定扣款' + numFiled.amount_val + '元?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }
      ).then(() => {
        afterDoPublish('')
      })
    }
    const billPrefix=()=>{
      let str="";
      switch(relateBillCodePrefix.value){
        case 1:
          str="MR";
          break;
        case 2:
          str="QX";
          break;
        case 3:
          str="LS";
          break;
        case 4:
          str="CL";
          break;
        case 5:
          str="DF";
          break;
      }

      return str;
    }
    //(relateBillCodePrefix.value === 3 ? 'LS' : (relateBillCodePrefix.value === 4 ? 'CL' : (relateBillCodePrefix.value === 1 ? 'MR' : 'QX')))
    const afterDoPublish = (pwd) => {
      doConsume({
        bill_code: billPrefix() + relateBillCode.value,
        amount_val: numFiled.amount_val,
        card_id: scanField.card.card_id,
        pwd: pwd != '' ? md5(pwd) : ''
      }, (res) => {
        scanField.card = {}
        numFiled.amount_val = '0'
        resultField.printResult = res
        resultField.dialogResultVisible = true
      }, (error) => {
        if (error.code == -799010) {
          pwdField.showPwdPage = true
        }
      })
    }
    const currentDate = new Date()
    const relateBillCode = ref('00' + currentDate.getFullYear() + (currentDate.getMonth() + 101).toString().substring(1) + (currentDate.getDate() + 100).toString().substring(1))
    const relateBillCodePrefix = ref(1)
    return {
      fromw,
      relateBillCode,
      relateBillCodePrefix,
      doPublish,
      ...toRefs(resultField),
      ...toRefs(numFiled),
      ...toRefs(scanField),
      ...toRefs(pwdField)
    }
  }
}
</script>
<style scoped>
</style>
